import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Section from 'layouts/Section/Section';

import InquiryForm from 'components/InquiryForm/InquiryForm';
import ThankYouMessage from 'components/ThankYouMessage/ThankYouMessage';
import Title from 'components/Title/Title';

const Inquiry = () => {
  const { hash } = useLocation();
  const [isShowThankYouMessage, setIsShowThankYouMessage] = useState(false);

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [hash]);
  return (
    <Section id="form" background="--brand-primary-lighten">
      <Title title="Is Joblio Right for Your Business?">
        We’ve got a team of experienced cross-cultural human recruitment
        specialists to answer this question for you! Let’s chat about your
        retention goals and financial rationalization, as well as our
        proprietary talent catalog and Applicant Concierge Experience (ACE)
        program.
      </Title>
      <InquiryForm setIsShowThankYouMessage={setIsShowThankYouMessage} />
      <ThankYouMessage isShowThankYouMessage={isShowThankYouMessage} />
    </Section>
  );
};

export default Inquiry;
